import { render, staticRenderFns } from "./RiskUnitStop.vue?vue&type=template&id=5dbf0d5c&scoped=true"
import script from "./RiskUnitStop.vue?vue&type=script&lang=js"
export * from "./RiskUnitStop.vue?vue&type=script&lang=js"
import style0 from "./RiskUnitStop.vue?vue&type=style&index=0&id=5dbf0d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbf0d5c",
  null
  
)

export default component.exports